const __vite__mapDeps = (
  i,
  m = __vite__mapDeps,
  d = m.f ||
    (m.f = [
      "./dialog-CgAbLcrp.js",
      "./component-B88NZlIm.js",
      "./utilities-D-QcnR4L.js",
      "./events-CnaEWcY_.js",
      "./dialog-COJ4SSlp.css",
      "./carousel-embla-DDt0pUdq.js",
      "./embla-tQScX_QI.js",
      "./predictive-search-CftSNELR.js",
      "./morph-B2Dsbee-.js",
    ])
) => i.map((i) => d[i]);
import "./liquid-ajax-cart-CD-8Lu3e.js";
import { C as v, b as j, c as x } from "./events-CnaEWcY_.js";
import { f as A } from "./utilities-D-QcnR4L.js";
const g = "modulepreload",
  L = function (r, t) {
    return new URL(r, t).href;
  },
  y = {},
  m = function (t, o, e) {
    let d = Promise.resolve();
    if (o && o.length > 0) {
      let C = function (s) {
        return Promise.all(
          s.map((u) =>
            Promise.resolve(u).then(
              (l) => ({ status: "fulfilled", value: l }),
              (l) => ({ status: "rejected", reason: l })
            )
          )
        );
      };
      const n = document.getElementsByTagName("link"),
        i = document.querySelector("meta[property=csp-nonce]"),
        h = i?.nonce || i?.getAttribute("nonce");
      d = C(
        o.map((s) => {
          if (((s = L(s, e)), s in y)) return;
          y[s] = !0;
          const u = s.endsWith(".css"),
            l = u ? '[rel="stylesheet"]' : "";
          if (e)
            for (let f = n.length - 1; f >= 0; f--) {
              const p = n[f];
              if (p.href === s && (!u || p.rel === "stylesheet")) return;
            }
          else if (document.querySelector(`link[href="${s}"]${l}`)) return;
          const c = document.createElement("link");
          if (
            ((c.rel = u ? "stylesheet" : g),
            u || (c.as = "script"),
            (c.crossOrigin = ""),
            (c.href = s),
            h && c.setAttribute("nonce", h),
            document.head.appendChild(c),
            u)
          )
            return new Promise((f, p) => {
              (c.addEventListener("load", f),
                c.addEventListener("error", () => p(new Error(`Unable to preload CSS for ${s}`))));
            });
        })
      );
    }
    function a(n) {
      const i = new Event("vite:preloadError", { cancelable: !0 });
      if (((i.payload = n), window.dispatchEvent(i), !i.defaultPrevented)) throw n;
    }
    return d.then((n) => {
      for (const i of n || []) i.status === "rejected" && a(i.reason);
      return t().catch(a);
    });
  };
let q = !1;
function T() {
  q ||
    ((q = !0),
    document.addEventListener("liquid-ajax-cart:init", () => {
      const r = window.liquidAjaxCart?.cart ?? null;
      document.dispatchEvent(
        new v(r, "liquid-ajax-cart:init", {
          source: "liquid-ajax-cart",
          itemCount: r?.item_count ?? 0,
        })
      );
    }),
    document.addEventListener("liquid-ajax-cart:request-end", (r) => {
      const { requestState: t } = r.detail,
        o = window.liquidAjaxCart?.cart ?? null;
      if (!t.responseData?.ok || t.fetchError) {
        const a = t.responseData?.body ?? {};
        document.dispatchEvent(
          new j(
            "liquid-ajax-cart",
            a.message ?? t.fetchError ?? "Cart request failed",
            a.description ?? null,
            a.errors ?? null
          )
        );
        return;
      }
      const d = {
        source: "liquid-ajax-cart",
        requestType: t.requestType,
        itemCount: o?.item_count ?? 0,
        sections: t.requestBody?.sections ?? null,
      };
      t.requestType === "add"
        ? document.dispatchEvent(new x(o, "liquid-ajax-cart", d))
        : document.dispatchEvent(new v(o, "liquid-ajax-cart", d));
    }));
}
function S() {
  if (!window.Shopify?.analytics?.publish) return;
  function r() {
    return window.liquidAjaxCart?.subscribeToCartAjaxRequests
      ? (window.liquidAjaxCart.subscribeToCartAjaxRequests((t) => {
          if (t.requestType !== "add" || t.requestState !== "end" || !t.responseData?.ok) return;
          (t.responseData.body?.items || []).forEach((e) => {
            window.Shopify.analytics.publish("product_added_to_cart", {
              cartLine: {
                quantity: e.quantity,
                merchandise: {
                  id: `gid://shopify/ProductVariant/${e.variant_id}`,
                  title: e.variant_title || e.title,
                  product: {
                    id: `gid://shopify/Product/${e.product_id}`,
                    title: e.product_title || e.title,
                    vendor: e.vendor,
                    type: e.product_type,
                    untranslatedTitle: e.product_title || e.title,
                    url: window.location.origin + e.url,
                  },
                  image: e.image ? { src: e.image } : void 0,
                  price: {
                    amount: e.price / 100,
                    currencyCode: window.Shopify?.currency?.active || "EUR",
                  },
                  sku: e.sku,
                  untranslatedTitle: e.variant_title || e.title,
                },
              },
            });
          });
        }),
        !0)
      : !1;
  }
  r() ||
    document.addEventListener("liquid-ajax-cart:init", () => {
      r();
    });
}
document.querySelector("[data-dialog], [data-modal], dialog-component") &&
  m(
    () => import("./dialog-CgAbLcrp.js").then((r) => r.d),
    __vite__mapDeps([0, 1, 2, 3, 4]),
    import.meta.url
  );
document.readyState === "complete" ? E() : window.addEventListener("load", E);
function E() {
  document.querySelector("carousel-embla") &&
    m(() => import("./carousel-embla-DDt0pUdq.js"), __vite__mapDeps([5, 1, 2, 6]), import.meta.url);
}
document.querySelector("[data-predictive-search], predictive-search-component") &&
  m(
    () => import("./predictive-search-CftSNELR.js").then((r) => r.p),
    __vite__mapDeps([7, 1, 2, 8, 3]),
    import.meta.url
  );
function w() {
  return window.liquidAjaxCart && typeof window.liquidAjaxCart.conf == "function"
    ? (window.liquidAjaxCart.conf("binderFormatters", { money: (r) => A(parseFloat(r)) }), !0)
    : !1;
}
w() ||
  document.addEventListener("liquid-ajax-cart:init", () => {
    w();
  });
document.addEventListener("liquid-ajax-cart:request-start", (r) => {
  const { requestState: t } = r.detail;
  t.requestType === "add" && t.requestBody && delete t.requestBody.sections;
});
T();
S();
document.readyState === "complete" ? _() : window.addEventListener("load", _);
function _() {
  setTimeout(() => {
    m(() => import("./cart-analytics-CrQXTU1v.js"), [], import.meta.url);
  }, 1500);
}
(function () {
  const t = new Set();
  let o,
    e = null;
  document.addEventListener("mouseover", (d) => {
    const a = d.target.closest("a[href]");
    if (a === e || (clearTimeout(o), (e = a), !a)) return;
    const n = a.href;
    !n ||
      !n.startsWith(location.origin) ||
      t.has(n) ||
      (o = setTimeout(() => {
        const i = document.createElement("link");
        ((i.rel = "prefetch"), (i.href = n), document.head.appendChild(i), t.add(n));
      }, 200));
  });
})();
